// extracted by mini-css-extract-plugin
export default {"font":"styles_font__9kHgx","font-container":"styles_font-container__v3+je"};